import { useEffect, useRef, useState } from "react";

const ScrollReveal = ({ 
  children, 
  direction = "left", // "left", "right", "up", "down"
  delay = 0,
  duration = 1000,
  className = ""
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "50px"
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  const getTransform = () => {
    if (isVisible) return "translate(0, 0)";
    
    switch (direction) {
      case "left":
        return "translate(-100px, 0)";
      case "right":
        return "translate(100px, 0)";
      case "up":
        return "translate(0, 100px)";
      case "down":
        return "translate(0, -100px)";
      default:
        return "translate(-100px, 0)";
    }
  };

  return (
    <div
      ref={elementRef}
      className={className}
      style={{
        transform: getTransform(),
        opacity: isVisible ? 1 : 0,
        transition: `all ${duration}ms cubic-bezier(0.4, 0, 0.2, 1) ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
